module.exports = __webpack_public_path__ + "static/media/common-file-award.2557216b.svg";